import '../App.css';
import about from './about.jpg';


const About = ({resumeInfo}) => {


    

    return(
        <div className='title-pic-border'>
            <div className='aboutflex'>
                <div className='aboutdiv'>
                    <h1 className='abouttitle'>Hi</h1>
                    <p className='aboutbio'>
                    My name is Marc and I’m an industrial designer currently based in New York. For the past 3 years, I have focused on full-phase product development, taking products from concept to market. I have designed for a wide range of product categories, including consumer electronics, dinnerware, and dog toys. With each product, I collaborate closely with clients and overseas factories to ensure a successful launch. I enjoy designing through complex problems, and I am always looking for ways to continue growing as a designer.
                    </p>
                    <p className='aboutbio'>
                    marcsharrer5@gmail.com
                    </p>
                    <p className='aboutbio'>
                    {resumeInfo !== {} ? <a className='resume' href={`${process.env.PUBLIC_URL}/userdata/resume/${resumeInfo}`} target='_blank' rel='noreferrer' >resume</a> : <>resume</>}
                    </p>
                </div>
                <img src={about} className='aboutportrait' alt='Marc sitting on a rock' />

            </div>
        </div>
        
    )

}

export default About;